const PriceRulesTableRows = ({ rowsData, deleteTableRows, handleChange }) => {
    return (
        rowsData.map((data, index) => {
            const { priceruleid, quantitytobuy,flatdiscountperitem,percentoffperitem} = data;
            return (
                <tr key={index}>
                    <td>
                        <input type='hidden' name="priceruleid" value={priceruleid} />
                        <input type='text' className="form-control" name="quantitytobuy" value={quantitytobuy} onChange={(evnt) => (handleChange(index, evnt))}/>
                    </td>
                    <td>
                        <input type='text' className="form-control" name="flatdiscountperitem" value={flatdiscountperitem} onChange={(evnt) => (handleChange(index, evnt))}/>
                    </td>
                    <td>
                        <input type='text' className="form-control" name="percentoffperitem" value={percentoffperitem} onChange={(evnt) => (handleChange(index, evnt))}/>
                    </td>

                    <td>
                        <i
                            className="fa fa-trash text-red fa-2x"
                            data-bs-toggle="tooltip"
                            title="Delete" 
                            onClick={() => {
                                deleteTableRows(index);
                            }}
                        />
                    </td>
                </tr >
            )
        })
    )
}

export default PriceRulesTableRows;